export default "__VITE_ASSET__BXBragVD__"